export default __webpack_public_path__ + "img/homepage.section4.04.asset.a17f9ddd.jpg";